import moment from 'moment'
import axios from 'axios'
import CKEDITOR from 'CKEDITOR'
export const baseUrl = process.env.NODE_ENV === 'production' ? 'https://exam.sciencereading.cn' : 'https://exam.sciencereading.cn'
// export const baseUrl = process.env.NODE_ENV === 'production' ? 'http://192.168.31.60:8080' : 'http://192.168.30.198:9527'
//export const baseUrl = process.env.NODE_ENV === 'production' ? 'http://192.168.33.61:9527' : 'http://192.168.33.61:9527'
export const errorMessage = '服务器错误,请重试!'

// 导入默认头信息
export const headers = {
  // 'Content-Type': 'application/x-www-form-urlencoded',
  Authentication: localStorage.getItem("token"),
  ClientId: "osca.web"
}

// 题目来源
export const questionSourceEnum = {
  1: '我的题库',
  2: '本校题库',
  3: '专家题库'
}

// 题目难易度
export const questionDifficultyEnum = {
  2: '简单',
  3: '中等',
  4: '难题'
}
// 题目难易度
export const questionDifficultyArray = [
  {
    id: 1,
    name: '简单'
  },
  {
    id: 2,
    name: '中等'
  },
  {
    id: 3,
    name: '难题'
  }
]

export const questionDifficultyArrayAll = [
  {
    id: 0,
    name: '不限'
  },
  {
    id: 1,
    name: '简单'
  },
  {
    id: 2,
    name: '中等'
  },
  {
    id: 3,
    name: '难题'
  }
]
// 会员类型
export const memberTypeEnum = [
  {
    id: 1,
    name: '系统管理员'
  },
  {
    id: 2,
    name: '科目管理员'
  },
  {
    id: 3,
    name: '审核员'
  },
  {
    id: 4,
    name: '教师'
  },
  {
    id: 5,
    name: '助教'
  },
  {
    id: 6,
    name: '学生'
  }
]

// 作业状态码
export const homeworkStatus = [
  {
    id: 2,
    name: '待批改'
  },
  {
    id: 1,
    name: '未提交'
  },
  {
    id: 3,
    name: '自动批改完成'
  },
  {
    id: 4,
    name: '教师批改完成'
  },
  {
    id: 5,
    name: '成绩已发布'
  }
]

export function htmlEncodeByRegExp (str) {
  let s = ''
  if (str.length === 0) return ''
  s = str.replace(/&/g, '&amp;') // eslint-disable-line
  s = s.replace(/</g, '&lt;') // eslint-disable-line
  s = s.replace(/>/g, '&gt;') // eslint-disable-line
  s = s.replace(/ /g, '&nbsp;') // eslint-disable-line
  s = s.replace(/\'/g, '&#39;') // eslint-disable-line
  s = s.replace(/\'/g, '&quot;') // eslint-disable-line
  return s
}

/***
 * 数组转对象
 * arr 值的格式为 { id: 1, name: 'test' }
 */
export function transformArrayFormatObject (arr) {
  let result = {}
  if (!Array.isArray(arr)) return null
  arr.forEach(item => {
    result[item.id] = item.name
  })
  return result
}

/**
 * params test 入参是 获取到的富文本的内容
 * 检测富文本是否只输入空格
 * str 入参为富文本内容
 * return Boolean true  说明只有空格, 反之则包含其他的内容
 */
export function checkTextAreaIsOnlyWhitespace (test) {
  // let flag = CKEDITOR.tools.isEmpty(content)
  // let result = test.trim().length
  // if (test && test.length) {
  //   let str = test.replace(/\s*/g, '')
  //   let content = str
  //   if (str.indexOf('>') > -1) {
  //     let scriptLength = str.split('>')[0].length + 1 // 设置标签长度 <p> <div> 等标签
  //     let lastIndex = str.lastIndexOf('<')
  //     content = str.substring(scriptLength, lastIndex)
  //   }
  //   let result = content.replace(/&nbsp;/g, '').replace(/\s*/g, '')
  //   if (result.length) return false
  // }
  return test && CKEDITOR.tools.isEmpty(test)
}

// 用户操作进行index排序 样题调整index排序
export function customerOperationSort (data) {
  let arr = []
  if (Array.isArray(data)) {
    data.map((item, index) => {
      let list = item.questionVOList
      const preTotal = data.filter((_, preIndex) => preIndex < index).reduce((total, item) => total + ((item.questionVOList && item.questionVOList.length) || 0), 0)
      list.map((obj, objIndex) => {
        obj.orderNumber = objIndex + 1 + preTotal
      })
      arr.push({
        ...item
      })
      arr[index].questionVOList = list
    })
  }
  return arr
}

export function getRandomId () {
  return (new Date()).valueOf() + (Math.random() * 1000).toFixed(0)
}

/**
 * 此方法的作用是为了规避直接使用标签直接下载资源而无法进行鉴权的特殊方法,
 * 此方法有缺陷,即在文件很大的时候，不能进行先播放部分资源后续在加载，而是全部下载好资源
 * @param {*} url 下载文件所需要的url,
 */
export function transformStreamToBlob(url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      headers,
      responseType: 'blob'
    }).then(res => {
      let blob = res.data
      resolve(blob)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 计算两个日期差值
 * @param {*} endTime 结束时间
 * @param {*} startTime 开始时间
 * @param {*} formatType 计算类型 传入的参数可以 day（相差天） || hour （相差小时） || minute（相差分钟）
 */
export function calculateDateDuration (startTime, endTime, formatType = 'minute') {
  if (formatType === 'day' || formatType === 'hour' || formatType === 'minute') {
    let t1 = moment(startTime);
    let t2 = moment(endTime);
    let duration = t2.diff(t1, formatType)
    return duration
  }
  return -1
}

/**
 * 移除obj属性为null的key
 */
export function removePropertyOfNull (obj) {
  Object.keys(obj).forEach(item=>{
    if(!obj[item])  delete obj[item]
  })
  return obj
}

// 导出Excel公用方法
export function exportMethod(data) {
  axios({
      method: data.method,
      url: `${baseUrl}${data.url}${data.params ? '/' + data.params : ''}`,
      responseType: 'blob',
      headers:{'Authentication':`${headers.Authentication}`}
  }).then((res) => {
      const link = document.createElement('a')
      let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)

      // link.download = res.headers['content-disposition'] //下载后文件名
      link.download = data.fileName //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
  }).catch(error => {
      this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
      })
  })
}

// 导出Excel公用方法
export function exportMethods(data) {
  var urlLink = ''
  for(var i in data.params) {
    urlLink += '&' + i + '=' + data.params[i]
  }
  urlLink = urlLink.substring(1)
  axios({
    method: data.method,
    url: `${baseUrl}${data.url}${data.params ? '?' + urlLink : ''}`,
    responseType: 'blob',
    headers:{'Authentication':`${headers.Authentication}`}
  }).then((res) => {
      const link = document.createElement('a')
      let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      // link.download = res.headers['content-disposition'] //下载后文件名
      link.download = data.fileName //下载的文件名
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
  }).catch(error => {
      this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
      })
  })
}

export const single = {
  questionId: 1,
  questionTypeId: 1,
  title: '',
  questionVOList: [
    {
      questionId: 1,
      optionText: '{"title":"A.","content":""}'
    },
    {
      questionId: 2,
      optionText: '{"title":"B.","content":""}'
    },
    {
      questionId: 3,
      optionText: '{"title":"C.","content":""}'
    },
    {
      questionId: 4,
      optionText: '{"title":"D.","content":""}'
    }
  ],
  optionDetailVOList: [
    {
      questionId: 1,
      optionText: '{"title":"A.","content":""}'
    },
    {
      questionId: 2,
      optionText: '{"title":"B.","content":""}'
    },
    {
      questionId: 3,
      optionText: '{"title":"C.","content":""}'
    },
    {
      questionId: 4,
      optionText: '{"title":"D.","content":""}'
    }
  ],
  answer: '',
  analysis: ''
}
export const single2 = {
  questionId: 2,
  questionTypeId: 2,
  title: '',
  questionVOList: [
    {
      questionId: 1,
      optionText: '{"title":"A.","content":""}'
    },
    {
      questionId: 2,
      optionText: '{"title":"B.","content":""}'
    },
    {
      questionId: 3,
      optionText: '{"title":"C.","content":""}'
    },
    {
      questionId: 4,
      optionText: '{"title":"D.","content":""}'
    }
  ],
  optionDetailVOList: [
    {
      questionId: 1,
      optionText: '{"title":"A.","content":""}'
    },
    {
      questionId: 2,
      optionText: '{"title":"B.","content":""}'
    },
    {
      questionId: 3,
      optionText: '{"title":"C.","content":""}'
    },
    {
      questionId: 4,
      optionText: '{"title":"D.","content":""}'
    }
  ],
  answer: '',
  analysis: ''
}
export const single3 = {
  questionId: 3,
  questionTypeId: 3,
  title: '',
  answer: '',
  analysis: ''
}
export const single4 = {
  questionId: 4,
  questionTypeId: 4,
  title: '',
  // answer: '',
  answer:"[{\"title\":\"填空1\",\"content\":\"<p>答案1</p >\"},{\"title\":\"填空2\",\"content\":\"<p>答案2</p >\"}]", // eslint-disable-line
  analysis: ''
}
export const single5 = {
  questionId: 5,
  questionTypeId: 5,
  title: '',
  answer: '',
  analysis: ''
}
export const single6 = {
  questionId: 6,
  questionTypeId: 6,
  title: '',
  subQuestionList: [
    {
      subId: 1925435455222,
      questionTypeId: 1,
      title: '',
      questionVOList: [
        {
          questionId: 1,
          optionText: "{\"title\":\"A.\",\"content\":\"\"}"
        },
        {
          questionId: 2,
          optionText: "{\"title\":\"B.\",\"content\":\"\"}"
        },
        {
          questionId: 3,
          optionText: "{\"title\":\"C.\",\"content\":\"\"}"
        },
        {
          questionId: 4,
          optionText: "{\"title\":\"D.\",\"content\":\"\"}"
        }
      ],
      optionDetailVOList: [
        {
          questionId: 1,
          optionText: "{\"title\":\"A.\",\"content\":\"\"}"
        },
        {
          questionId: 2,
          optionText: "{\"title\":\"B.\",\"content\":\"\"}"
        },
        {
          questionId: 3,
          optionText: "{\"title\":\"C.\",\"content\":\"\"}"
        },
        {
          questionId: 4,
          optionText: "{\"title\":\"D.\",\"content\":\"\"}"
        }
      ],
      answer: '',
      analysis: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/util.js